import * as React from "react"
import {IntlProvider as ReactIntlProvider} from "react-intl"

const DATE_FORMATS = {
  full: {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
  "full-short": {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
  month: {
    month: "long",
    year: "numeric",
  },
  day: {
    month: "long",
    year: "numeric",
    day: "2-digit",
  },
  short: {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  },
}

const NUMBER_FORMATS = {
  currency: {
    style: "currency",
    currency: "EUR",
  },
}

const FORMATS = {
  date: DATE_FORMATS,
  number: NUMBER_FORMATS,
}

/* exemple usage: <FormattedDate value={publishedAt} format="full" /> */
export const IntlProvider = ({locale, messages, children}) => (
  <ReactIntlProvider
    locale={locale}
    messages={messages}
    formats={FORMATS}
    // textComponent={React.Fragment}
  >
    {children}
  </ReactIntlProvider>
)
